import { Incentive } from "@/pages/incentive";
import { IncentiveManagerPage } from "@/pages/incentive/manager";
import M1Dashboard from "@/pages/m1/gantt";
import M1Overview from "@/pages/m1/overview";
import M1ShiftReport from "@/pages/m1/shift-report";
import M1Campaign from "@/pages/m1/schedule";
import { MILL_1 } from "../mill-config/mill-config";

export const routeM1Overview = "/m1/overview";
export const routeM1ShiftReport = "/m1/shift-report";
export const routeM1Schedule = "/m1/schedule";
export const routeM1StackerProduction = "/stacker-production";
export const routeM1Gantt = "/m1/gantt";
export const routeM1Incentive = "/m1/incentive";
export const routeM1IncentiveManager = "/m1/incentive/manager";
export const m1GanttPermission = "ui.navbar.m1.gantt";
export const m1MillSchedulePermission = "ui.navbar.m1.mill.schedule";
export const m1ShiftReportPermission = "ui.navbar.m1.shift.report";
const m1StackerProductionPermission = "ui.navbar.m1.stacker.production";
export const m1IncentiveDashboardPermission =
	"ui.navbar.m1.incentive.dashboard";
export const m1IncentiveManagerPermission = "ui.navbar.m1.incentive.manager";
export const m1MillOverviewPermission = "ui.navbar.m1.mill.overview";

export const m1Routes = [
	{
		path: routeM1Overview,
		element: <M1Overview />,
		permission: m1MillOverviewPermission,
	},
	{
		path: routeM1ShiftReport,
		element: <M1ShiftReport />,
		permission: m1ShiftReportPermission,
	},
	{
		path: `${routeM1ShiftReport}/:shiftId`,
		element: <M1ShiftReport />,
		permission: m1ShiftReportPermission,
	},
	{
		path: routeM1Schedule,
		element: <M1Campaign />,
		permission: m1MillSchedulePermission,
	},
	{
		path: routeM1Incentive,
		element: <Incentive assetId={MILL_1.id} />,
		permission: m1IncentiveDashboardPermission,
	},
	{
		path: routeM1IncentiveManager,
		element: <IncentiveManagerPage assetId={MILL_1.id} />,
		permission: m1IncentiveManagerPermission,
	},
	{
		path: `${routeM1Schedule}/:campaignId`,
		element: <M1Campaign />,
		permission: m1MillSchedulePermission,
	},
	{
		path: routeM1StackerProduction,
		element: <M1ShiftReport />,
		permission: m1StackerProductionPermission,
	},
	{
		path: routeM1Gantt,
		element: <M1Dashboard />,
		permission: m1GanttPermission,
	},
	{
		path: `${routeM1Gantt}/:shiftId`,
		element: <M1Dashboard />,
		permission: m1GanttPermission,
	},
	{
		path: `${routeM1StackerProduction}/:shiftId`,
		element: <M1ShiftReport />,
		permission: m1StackerProductionPermission,
	},
];
